<script lang="ts">
    export let left = 20
    export let top = 20

    let moving = false

    function onMouseDown() {
        moving = true
    }

    function onMouseMove(e) {
        if (moving) {
            left += e.movementX
            top += e.movementY
        }
    }

    function onMouseUp() {
        moving = false
    }

    // 	$: console.log(moving);
</script>

<section on:pointerdown={onMouseDown} style="left: {left}px; top: {top}px;" class="draggable">
    <slot></slot>
</section>

<svelte:window on:pointerup|stopPropagation={onMouseUp} on:pointermove|stopPropagation={onMouseMove} />

<style>
    .draggable {
        user-select: none;
        touch-action: none;
        cursor: move;
        /* background-color: red; */
        position: absolute;
        overflow: visible;
    }
</style>
